import React from "react";
import { NumericFormat } from "react-number-format";
import "devextreme/data/odata/store";
import deleteImg from "../../images/budget/delete.png";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import { Switch } from "@mui/material";
import { Center } from "devextreme-react/map";
import { Form } from "react-bootstrap";
import { MAX_COST, MIN_COST } from "../../constants";

class MonthPosition extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.id,
      showFilterRow: true,
      showHeaderFilter: false,
      rowAlternationEnabled: true,
      showModal: false,
      showEditModal: false,
      net: this.props.net ? this.props.net : 0,
      isLC: this.props.isLC,
      technical_cost: this.props.technical_cost
        ? this.props.technical_cost
        : 0,
      fee_value: this.props.fee_value ? this.props.fee_value : 0,
      fee_calculated: this.props.fee_calculated
        ? this.props.fee_calculated
        : 0,
      final_cost: this.props.final_cost ? this.props.final_cost : 0,
      units: this.props.units ? this.props.units : 0,
      isSampling: this.props.isSampling,
      showUnitPositionSampling:  this.props.showUnitPositionSampling
      ? this.props.showUnitPositionSampling
      : true,
      monthNumber: this.props.monthNumber,
      positionId: this.props.positionId ? this.props.positionId : 0,
      positionsData: this.props.positionsData,
      thousandSeparator: ",",
      decimalSeparator: ".",
      isValid: this.props.isValid
    };

    this.budgetListNameRef = React.createRef();
    this.technical = React.createRef();
  }
  selectedChanged(e) {
    console.log("i am inside setupChanged MonthPosition.js")
    this.setState({
      selectedRowIndex: e.component.getRowIndexByKey(e.selectedRowKeys[0]),
    });
  }

  componentDidMount() {
    console.log("i am inside componentDidMount MonthPosition.js")
    var l_thousandSeparator =
      navigator.language.indexOf("fr") > -1
        ? " "
        : navigator.language.indexOf("en-US") > -1
        ? ","
        : navigator.language.indexOf("de-DE") > -1
        ? "."
        : ",";
    var l_decimalSeparator =
      navigator.language.indexOf("fr") > -1
        ? ","
        : navigator.language.indexOf("en-US") > -1
        ? "."
        : navigator.language.indexOf("de-DE") > -1
        ? ","
        : ".";

    this.setState({
      thousandSeparator: l_thousandSeparator,
      decimalSeparator: l_decimalSeparator,
    });

    var net_value = this.state.net === "" ? 0 : this.state.net;
    var fee_value = this.state.fee_value === "" ? 0 : this.state.fee_value;
    var technicalcost_value =
      this.state.technical_cost === "" ? 0 : this.state.technical_cost;

    this.setState(
      {
        fee_calculated: this.state.isLC
          ? fee_value
          : (fee_value / 100) * net_value,
        final_cost:
          parseFloat(net_value) +
          parseFloat(
            this.state.isLC ? fee_value : (fee_value / 100) * net_value
          ) +
          parseFloat(technicalcost_value),
      },this.returnMonthSetup
    );
  }
  componentDidUpdate() {
    console.log("i am inside componentDidUpdate MonthPosition.js")
    var id_new = this.props.id;
    if (this.state.id != id_new) {
      this.setState({ id: id_new });
    }
    var net_new = this.props.net;
    if (this.state.net != net_new) {
      this.setState({
        net: net_new,
        fee_calculated: this.props.isLC
          ? this.props.fee_value
          : (this.props.fee_value / 100) * net_new,
        final_cost:
          parseFloat(net_new) +
          parseFloat(
            this.state.isLC
              ? this.props.fee_value
              : (this.props.fee_value / 100) * net_new
          ) +
          parseFloat(this.props.technical_cost),
      }
     );
    }

    var positionId_new = this.props.positionId;
    if (this.state.positionId != positionId_new) {
      this.setState({ positionId: positionId_new });
    }
  }
  NetAmountChanged(event) {
    console.log("i am inside NetAmountChanged")
    var value = event.value == "" ? 0 : event.floatValue;
    var x_fee_value = this.state.fee_value == "" ? 0 : this.state.fee_value;
    var x_technicalcost =
      this.state.technical_cost == "" ? 0 : this.state.technical_cost;
      let x_fee_calculated; 

      if (this.state.isLC) {
        x_fee_calculated = x_fee_value;
      } else {
        let calculatedValue = parseFloat((x_fee_value * value) / 100);
        if (calculatedValue === 0) {
          x_fee_calculated = "";
        } else {
          x_fee_calculated = calculatedValue;
        }
      }
    var x_final_cost =
      parseFloat(value) +
      parseFloat(this.state.isLC ? x_fee_value : (x_fee_value / 100) * value) +
      parseFloat(x_technicalcost);

    this.setState(
      {
        net: value,
        fee_value: x_fee_value,
        fee_calculated: x_fee_calculated,
        technical_cost: x_technicalcost,
        final_cost:
          x_final_cost.countDecimals() > 2
            ? x_final_cost.toFixed(4)
            : x_final_cost,
      },
      this.returnMonthSetup
    );
  }
  feeAmountChanged(event) {
    console.log("i am inside feeAmountChanged")
    var value = event.value == "" ? 0 : event.floatValue;
    var net_value = this.state.net == "" ? 0 : this.state.net;
    if (value == 0) {
      this.setState({ fee_value: 0 });
    }
    this.setState(
      {
        fee_value: value,
        fee_calculated: this.state.isLC
          ? value
          : (value / 100) * this.state.net,
        final_cost:
          parseFloat(net_value) +
          parseFloat(this.state.isLC ? value : (value / 100) * net_value) +
          parseFloat(this.state.technical_cost),
      },
      this.returnMonthSetup
    );
  }

  unitChanged(event) {
    console.log("i am inside unitChanged")
    var unitvalue = event.value == "" ? 0 : event.floatValue;
    var value = this.state.net == "" ? 0 : this.state.net;
    var fee_value = this.state.fee_value == "" ? 0 : this.state.fee_value;
    var x_technicalcost =
      this.state.technical_cost == "" ? 0 : this.state.technical_cost;
    var x_fee_calculated = this.state.isLC
      ? fee_value
      : parseFloat((fee_value * this.state.net) / 100) == 0
      ? ""
      : this.state.isLC
      ? fee_value
      : parseFloat((fee_value * this.state.net) / 100);
    var x_final_cost =
      parseFloat(value) +
      parseFloat(this.state.isLC ? fee_value : (fee_value / 100) * value) +
      parseFloat(x_technicalcost);

    this.setState(
      {
        net: this.state.net == "" ? 0 : this.state.net,
        fee_calculated: x_fee_calculated,
        final_cost:
          x_final_cost.countDecimals() > 2
            ? x_final_cost.toFixed(4)
            : x_final_cost,
        units: unitvalue,
      },
      this.returnMonthSetup
    );
  }

  technicalCostAmountChanged(event) {
    console.log("i am inside technicalCostAmountChanged")
    var value = event.value == "" ? 0 : event.floatValue;
    var x_net_cost = this.state.net == "" ? 0 : this.state.net;
    var x_fee_calculated =
      this.state.fee_calculated == "" ? 0 : this.state.fee_calculated;
    var x_final_cost =
      parseFloat(x_net_cost) +
      parseFloat(parseFloat(x_fee_calculated).toFixed(4)) +
      parseFloat(value);

    this.setState(
      {
        technical_cost: value,
        final_cost:
          x_final_cost.countDecimals() > 2
            ? x_final_cost.toFixed(4)
            : x_final_cost,
      },
      this.returnMonthSetup
    );
  }

  switchHandler = (event) => {
    var x_technical_cost =
      this.state.technical_cost == "" ? 0 : this.state.technical_cost;
    var x_final_cost =
      parseFloat(this.state.net) + parseFloat(x_technical_cost);

    var isLC_Value = !this.state.isLC;
    var final_cost_value =
      x_final_cost.countDecimals() > 2 ? x_final_cost.toFixed(4) : x_final_cost;

    this.setState(
      {
        fee_value: 0,
        fee_calculated: 0,
        isLC: isLC_Value,
        final_cost: final_cost_value,
      },
      this.returnMonthSetup
    );
  };

  returnMonthSetup() {
    console.log("i am inside returnMonthSetup")
    let positionDetails = {
      positionId: this.state.positionId,
      net: this.state.net === "" ? 0 : this.state.net,
      technical_cost:
        this.state.technical_cost === "" ? 0 : this.state.technical_cost,
      fee_value: this.state.fee_value === "" ? 0 : this.state.fee_value,
      isLC: this.state.isLC,
      units: this.state.units,
      isSampling: this.state.isSampling,
      monthNumber: this.props.monthNumber,
      fee_calculated:
        this.state.fee_calculated === "" ? 0 : this.state.fee_calculated,
      final_cost: this.state.final_cost,
    };

    this.props.data.positionSetupChanged(this.state.id, positionDetails);
  }

  positionSelected = (event) => {
    console.log("i am inside positionSelected")
    this.setState({ positionId: event.target.value }, this.returnMonthSetup);
  }

  chkSampleChecked = (event) => {
    console.log("i am inside chkSampleChecked")
    var value = event.target.checked;
    this.setState(
      {
        isSampling: value,
      },
      this.returnMonthSetup
    );
  }

  deletePosition = (id) => {
    console.log("i am inside deletePosition")
    this.props.data.deletePosition(id);
  }

  isPositionIdInData(positionId) {
    return this.props.positionsData.some(item => item.props.value === positionId);
  }

  render() {
    const { positionId } = this.state;
    const isPositionIdValid = this.isPositionIdInData(positionId);
    return (
      <div
        className={`${
          !this.state.net && this.state.technical_cost && this.state.fee_value
            ? "div-monthly-setup-container_month padding-bot2"
            : (!this.state.net && this.state.technical_cost) ||
              (!this.state.net && this.state.fee_value)
            ? "div-monthly-setup-container_month padding-bot"
            : "div-monthly-setup-container_month"
        }`}
      >
        <div className="div-monthly-setup-container-header">
          <div className="div-monthly-setup-container-cell div-monthly-setup-container-col1">
            <Form.Control
              className= {`select-placeholder ${!this.props.isValid && "validation-control"}`} 
              onChange={this.positionSelected}
              value={!isPositionIdValid ? "" : positionId}
              disabled={this.props.hidePosValue}
              required
              as="select"
              defaultValue=""
            >
              {!isPositionIdValid && <option value={""}  className={"hidden-option"}>Position</option>}
              {this.props.positionsData}
            </Form.Control>
            {this.props.isValid ? null : (
              <p className="p-required-position">Required</p>
            )}            
          </div>
          <div className="div-monthly-setup-container-cell div-monthly-setup-container-col2">
            <NumericFormat
              thousandSeparator={this.state.thousandSeparator}
              decimalSeparator={this.state.decimalSeparator}
              ref="net"
              value={this.props.net === 0 ? "" : this.props.net}
              onValueChange={(event) => this.NetAmountChanged(event)}
              className={`${
                !this.state.net &&
                this.state.technical_cost &&
                this.state.fee_value
                  ? "validation-control budgetTextBox"
                  : (!this.state.net && this.state.technical_cost) ||
                    (!this.state.net && this.state.fee_value > 0)
                  ? "validation-control budgetTextBox"
                  : "budgetTextBox"
              }`}
              decimalScale={2}
              disabled={this.props.hidePosValue}
              isAllowed={(values) => {
                const { floatValue } = values;
                if (this.state.net == 0 && values.value == "") {
                  return false;
                } else if (this.state.net > 0 && values.value == "") {
                  return true;
                }

                return floatValue >= MIN_COST && floatValue <= MAX_COST;
              }}
            />
            {!this.state.net &&
            this.state.technical_cost &&
            this.state.fee_value ? (
              <p className="p-error2">
                Net cost for this month must be defined because a technical cost is entered
                <br />Net cost for this month must be defined because fees cost is entered
              </p>
            ) : !this.state.net && this.state.fee_value ? (
              <p className="p-error">
                Net cost for this month must be defined because fees cost is entered
              </p>
            ) : !this.state.net && this.state.technical_cost ? (
              <p className="p-error">
                Net cost for this month must be defined because a technical cost is entered
              </p>
            ) : (
              ""
            )}
          </div>
          <div className="div-monthly-setup-container-cell div-monthly-setup-container-col3">
            <NumericFormat
              thousandSeparator={this.state.thousandSeparator}
              decimalSeparator={this.state.decimalSeparator}
              ref={this.technical}
              value={
                this.props.technical_cost === 0 ? "" : this.props.technical_cost
              }
              onValueChange={(event) => this.technicalCostAmountChanged(event)}
              className="budgetTextBox"
              decimalScale={2}
              disabled={this.props.hidePosValue}
              isAllowed={(values) => {
                const { floatValue } = values;
                if (this.state.technical_cost == 0 && values.value == "") {
                  return false;
                } else if (
                  this.state.technical_cost > 0 &&
                  values.value == ""
                ) {
                  return true;
                }

                return floatValue >= MIN_COST && floatValue <= MAX_COST;
              }}
            />
          </div>
          <div
            className="div-monthly-setup-container-cell div-monthly-setup-container-col4"
          >
            %
            <Switch
              checked={this.state.isLC}
              onClick={this.switchHandler}
              disabled={this.props.hidePosValue}
            />
            LC
          </div>
          <div className="div-monthly-setup-container-cell div-monthly-setup-container-col5">
            <NumericFormat
              thousandSeparator={this.state.thousandSeparator}
              decimalSeparator={this.state.decimalSeparator}
              ref="fee_value"
              valueIsNumericString={true}
              value={this.props.fee_value === 0 ? "" : this.props.fee_value}
              onValueChange={(event) => this.feeAmountChanged(event)}
              className="budgetTextBox"
              decimalScale={2}
              disabled={this.props.hidePosValue}
              isAllowed={(values) => {
                const { floatValue } = values;

                if (this.state.fee_value == 0 && values.value == "") {
                  return false;
                } else if (this.state.fee_value > 0 && values.value == "") {
                  return true;
                }

                if (this.state.isLC) {
                  return floatValue >= MIN_COST && floatValue <= MAX_COST;
                } else {
                  return floatValue >= 0 && floatValue <= 100;
                }
              }}
            />
          </div>
          <div className="div-monthly-setup-container-cell div-monthly-setup-container-col6">
            <NumericFormat
              thousandSeparator={this.state.thousandSeparator}
              decimalSeparator={this.state.decimalSeparator}
              ref="fee_calculated"
              valueIsNumericString={true}
              value={
                this.state.fee_calculated === 0 ? "" : this.state.fee_calculated
              }
              decimalScale={2}
              disabled={true}
              className="budgetTextBox"
              isAllowed={(values) => {
                const { floatValue } = values;
                return floatValue >= MIN_COST && floatValue <= MAX_COST;
              }}
            />
          </div>
          <div className="div-monthly-setup-container-cell div-monthly-setup-container-col7">
            <NumericFormat
              thousandSeparator={this.state.thousandSeparator}
              decimalSeparator={this.state.decimalSeparator}
              value={this.state.final_cost === 0 ? "" : this.state.final_cost}
              ref="final_cost"
              className="budgetTextBox"
              decimalScale={2}
              disabled={true}
              isAllowed={(values) => {
                const { floatValue } = values;
                return floatValue >= MIN_COST && floatValue <= MAX_COST;
              }}
            />
          </div>
          <div
            className={
              this.state.showUnitPositionSampling
                ? "div-monthly-setup-container-cell div-monthly-setup-container-col8 "
                : "div-monthly-setup-container-cell div-monthly-setup-container-col8 hidden"
            }
          >
            <NumericFormat
              thousandSeparator={this.state.thousandSeparator}
              decimalSeparator={this.state.decimalSeparator}
              ref="units"
              value={this.props.units === 0 ? "" : this.props.units}
              disabled={this.props.hidePosValue}
              onValueChange={(event) => this.unitChanged(event)}
              className="budgetTextBox"
              decimalScale={2}
              isAllowed={(values) => {
                const { floatValue } = values;

                if (this.state.units == 0 && values.value == "") {
                  return false;
                } else if (this.state.units > 0 && values.value == "") {
                  return true;
                }

                return floatValue >= 0 && floatValue <= MAX_COST;
              }}
            />
          </div>
          <div
            className={
              this.state.showUnitPositionSampling
                ? "div-monthly-setup-container-cell div-monthly-setup-container-col9 "
                : "div-monthly-setup-container-cell div-monthly-setup-container-col9 hidden"
            }
          >
            <input
              type="checkbox"
              className="chk_sampling"
              checked={this.state.isSampling}
              ref="chk_sample"
              disabled={this.props.hideValue}
              onChange={(event) => this.chkSampleChecked(event)}
            />
          </div>
          <div
            className={
              this.state.showUnitPositionSampling
                ? "div-monthly-setup-container-cell div-monthly-setup-container-col10 "
                : "div-monthly-setup-container-cell div-monthly-setup-container-col10 hidden"
            }
          >
            <img
              style={{
                maxHeight: "16px",
                cursor: this.props.hideValue ? "not-allowed" : "pointer",
                opacity: this.props.hideValue ? "0.5" : "1",
              }}
              alt="deleting pos"
              src={deleteImg}
              onClick={
                this.props.hideValue
                  ? null
                  : (event) => this.deletePosition(this.state.id)
              }
              disabled={this.props.hidePosValue}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default MonthPosition;
